import { VaultData } from '../queries/vault';
import { VaultDetails } from '../store/vaults';
import { utils, BigNumber, constants } from 'ethers';

export function constructVaultDetails(vault: VaultData): VaultDetails {
  return {
    id: utils.getAddress(vault.id),
    address: utils.getAddress(vault.address),
    name: vault.name,
    blockCreated: parseInt(vault.blockCreated),
    feeTier: Number(vault.feeTier),
    liquidity: BigNumber.from(vault.liquidity),
    lowerTick: parseInt(vault.lowerTick),
    upperTick: parseInt(vault.upperTick),
    manager: vault.manager,
    managerFee: parseFloat(vault.managerFee),
    positionId: vault.positionId,
    token0: {
      ...vault.token0,
      symbol: vault.token0.symbol === "miMATIC" ? "MAI" : vault.token0.symbol,
      decimals: Number(vault.token0.decimals),
    },
    token1: {
      ...vault.token1,
      symbol: vault.token1.symbol === "miMATIC" ? "MAI" : vault.token1.symbol,
      decimals: Number(vault.token1.decimals),
    },
    totalSupply: BigNumber.from(vault.totalSupply),
    uniswapPool: vault.uniswapPool,
    tvl: 0,
    apr: parseFloat(vault.apr.averageApr),
    aprTimestamp: parseInt(vault.apr.timestamp),
    feesEarned0: BigNumber.from(vault.feeInfo.collect0).sub(
      BigNumber.from(vault.feeInfo.burn0)
    ),
    feesEarned1: BigNumber.from(vault.feeInfo.collect1).sub(
      BigNumber.from(vault.feeInfo.burn1)
    ),
    balance: constants.Zero,
    reserves0: constants.Zero,
    reserves1: constants.Zero,
    share0: constants.Zero,
    share1: constants.Zero,
    reward: constants.Zero,
    rewardTokenPrice: 0,
  }
}